import type { JSX } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { ViewProvider } from '../components/layout/ViewContext'; // Import ViewProvider
import AuditLogList from '../pages/admin/auditLogs/List';
import BulkEmailCreate from '../pages/admin/bulkEmail/Create';
import BulkEmailEdit from '../pages/admin/bulkEmail/Edit';
import BulkEmailList from '../pages/admin/bulkEmail/List';
import CompanyInfoCreate from '../pages/admin/companyInfo/Create';
import CompanyInfoEdit from '../pages/admin/companyInfo/Edit';
import CompanyInfoList from '../pages/admin/companyInfo/List';
import Dashboard from '../pages/admin/Dashboard';
import MemberCreate from '../pages/admin/member/Create';
import MemberEdit from '../pages/admin/member/Edit';
import MemberList from '../pages/admin/member/List';
import UserCreate from '../pages/admin/users/Create';
import UserEdit from '../pages/admin/users/Edit';
import UsersList from '../pages/admin/users/List';
import ForgotPassword from '../pages/public/ForgotPassword';
import Login from '../pages/public/Login';
import ResetPassword from '../pages/public/ResetPassword';
import Unsubscribe from '../pages/public/Unsubscribe';

import ClientList from '../pages/admin/client/List';
import ClientCreate from '../pages/admin/client/Create';
import ClientEdit from '../pages/admin/client/Edit';

import InvoiceList from '../pages/admin/invoice/List';
import InvoiceCreate from '../pages/admin/invoice/Create';
import InvoiceEdit from '../pages/admin/invoice/Edit';

import InvoiceTypeList from '../pages/admin/invoiceType/List';
import InvoiceTypeCreate from '../pages/admin/invoiceType/Create';
import InvoiceTypeEdit from '../pages/admin/invoiceType/Edit';

import InvoiceStatusList from '../pages/admin/invoiceStatus/List';
import InvoiceStatusCreate from '../pages/admin/invoiceStatus/Create';
import InvoiceStatusEdit from '../pages/admin/invoiceStatus/Edit';

import AccountsPackItemList from '../pages/admin/accountsPackItem/List';
import AccountsPackItemCreate from '../pages/admin/accountsPackItem/Create';
import AccountsPackItemEdit from '../pages/admin/accountsPackItem/Edit';

// Import route here

const AppRouter = (): JSX.Element => (
  <ViewProvider>
    {' '}
    {/* Wrap all routes in the ViewProvider */}
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />

        {/* Protected admin routes */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/auditlogs"
          element={
            <PrivateRoute>
              <AuditLogList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo"
          element={
            <PrivateRoute>
              <CompanyInfoList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo/create"
          element={
            <PrivateRoute>
              <CompanyInfoCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo/:id"
          element={
            <PrivateRoute>
              <CompanyInfoEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/bulkemails"
          element={
            <PrivateRoute>
              <BulkEmailList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bulkemails/create"
          element={
            <PrivateRoute>
              <BulkEmailCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bulkemails/:id"
          element={
            <PrivateRoute>
              <BulkEmailEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <UsersList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users/create"
          element={
            <PrivateRoute>
              <UserCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users/:id"
          element={
            <PrivateRoute>
              <UserEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/members"
          element={
            <PrivateRoute>
              <MemberList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/members/create"
          element={
            <PrivateRoute>
              <MemberCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/members/:id"
          element={
            <PrivateRoute>
              <MemberEdit />
            </PrivateRoute>
          }
        />

                    <Route
                        path="/admin/clients"
                        element={
                            <PrivateRoute>
                                <ClientList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/clients/create"
                        element={
                            <PrivateRoute>
                                <ClientCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/clients/:id"
                        element={
                            <PrivateRoute>
                                <ClientEdit/>
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/invoices"
                        element={
                            <PrivateRoute>
                                <InvoiceList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoices/create"
                        element={
                            <PrivateRoute>
                                <InvoiceCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoices/:id"
                        element={
                            <PrivateRoute>
                                <InvoiceEdit/>
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/invoicetypes"
                        element={
                            <PrivateRoute>
                                <InvoiceTypeList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoicetypes/create"
                        element={
                            <PrivateRoute>
                                <InvoiceTypeCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoicetypes/:id"
                        element={
                            <PrivateRoute>
                                <InvoiceTypeEdit/>
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/invoicestatuses"
                        element={
                            <PrivateRoute>
                                <InvoiceStatusList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoicestatuses/create"
                        element={
                            <PrivateRoute>
                                <InvoiceStatusCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/invoicestatuses/:id"
                        element={
                            <PrivateRoute>
                                <InvoiceStatusEdit/>
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/accountspackitems"
                        element={
                            <PrivateRoute>
                                <AccountsPackItemList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/accountspackitems/create"
                        element={
                            <PrivateRoute>
                                <AccountsPackItemCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/accountspackitems/:id"
                        element={
                            <PrivateRoute>
                                <AccountsPackItemEdit/>
                            </PrivateRoute>
                        }
                    />





      </Routes>
    </Router>
  </ViewProvider>
);

export default AppRouter;
